import type { TravelAgencyTour } from '@eliadmin/core/src/api/travel-agency/travel-agency-api';

import { HtmlRenderer } from '@eliadmin/core/src/components/ui/project-html-renderer';
import { TourTabHeading } from '../tour-content';
import { cn } from '@eliadmin/core/src/utils/style-utils';
import { TourBlogs } from '../../tour-blogs';
import { useLocaleStore } from '@eliadmin/core/src/stores/locale-store';

export function ProgramTab({ tour }: { tour: TravelAgencyTour }) {
  const locale = useLocaleStore(s => s.currentLocale);

  return (
    <div className="flex w-full flex-col items-start justify-start gap-6 lg:gap-8">
      <TourTabHeading title="Program" />
      <HtmlRenderer
        html={tour?.text_fields?.[0]?.value ?? ''}
        variant="description"
        className={cn('w-full', 'ea-tour__description-tab-content', 'ea-tour__program-content')}
      />
      {tour.id === 11 && <TourBlogs locale={locale} />}
    </div>
  );
}
